(function () {
    "use strict";

    angular
        .module("showcaseApp")
        .controller("ContentController", ContentController);

    ContentController.$inject = ["Principal"];

    function ContentController(Principal) {
        var contentVm = this;

        contentVm.account = null;
        contentVm.isTrialActive = false;

        contentVm.init = function () {
            loadAccount();
        };

        contentVm.init();

        function isNullOrUndefined(object) {
            return object === null || object === undefined;
        }

        function calculateIsTrial(account) {
            return (
                !isNullOrUndefined(account) &&
                !isNullOrUndefined(account.remainingTime) &&
                account.remainingTime > 0 &&
                account.remainingTime <= 7
            );
        }

        function loadAccount() {
            Principal.identity().then(function (account) {
                if (account) {
                    contentVm.account = angular.copy(account);
                    contentVm.isTrialActive = calculateIsTrial(account);
                }
            });
        }
    }
})();
